<template>
  <div class="member">
    <el-form ref="member_form" :model="member" label-width="80px" :rules="rules">
      <el-form-item label="用户姓名" prop="name">
        <el-input v-model="member.name"></el-input>
      </el-form-item>
      <el-form-item label class="avatar">
        <el-avatar shape="square" :size="150" :src="member.avatar" @error="true">
          <img :src="defaultAvatar" />
        </el-avatar>
      </el-form-item>
      <el-form-item label="性别" prop="gender">
        <el-select v-model="member.gender" placeholder="请选择性别">
          <el-option label="男" :value="1"></el-option>
          <el-option label="女" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="手机号码" prop="phone">
        <el-input v-model="member.phone"></el-input>
      </el-form-item>
      <el-form-item label="出生日期">
        <el-date-picker v-model="member.birthTime" type="date" placeholder="出生日期"></el-date-picker>
      </el-form-item>
      <el-form-item label="地址">
        <el-input v-model="member.address" class="address"></el-input>
      </el-form-item>
      <el-form-item label="备注">
        <el-input 
          v-model="member.remark" 
          type="textarea" 
          :rows="4"
          class="remark"
          placeholder="请输入备注信息"
        ></el-input>
      </el-form-item>
      <el-divider></el-divider>
      <el-form-item>
        <el-button type="primary" plain size="mini" @click="onSubmit('member_form')">{{btnName}}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { addMember,editMember } from "@/api/index";
import defaultTx from "../../assets/defaultTx.png";

export default {
  name: "member",
  props: {
    member: Object,
    operation: String
  },
  data() {
    return {
      defaultAvatar: defaultTx,
      btnName: "登记",
      rules: {
        name: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          { min: 1, max: 20, message: "长度必须1-20个字符", trigger: "blur" }
        ],
        gender: [{ required: true, message: "请选择性别", trigger: "blur" }],
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: "请输入正确的手机号",
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    onSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.operation === "add") {
            addMember(this.member).then(res => {
              if (res.success == true) {
                this.$refs[formName].resetFields();
                this.$emit("result", this.operation);
              } else {
                this.$notify.error({
                  title: '错误',
                  message: res.message
                })
              }
            });
          } else {
            editMember(this.member).then(res => {
              if (res.success == true) {
                this.$message({
                  showClose: true,
                  message: '修改成功',
                  type: "success"
                });
              } else {
                this.$notify.error({
                  title: '错误',
                  message: res.message
                })
              }
            });
          }
        } else {
          return false;
        }
      });
    }
  },
  created() {
    if (this.operation === "edit") {
      this.btnName = "更新";
    }
  }
};
</script>
<style lang="scss">
.member {
  padding: 20px;

  .el-input {
    width: 200px;
  }
  .address {
    width: 400px;
  }
  .remark {
    width: 500px;
  }
  .avatar {
    position: absolute;
    right: 50px;
    top: 20px;
  }
  .el-button {
    position: absolute;
    right: 0px;
    bottom: -20px;
  }
}
</style>
